export const analysisConstants = {
  ANALYSISASSIGNMENTOBJECT: 'ANALYSIS_ASSIGNMENT_OBJECT',
  ANALYSISTESTOBJECT: 'ANALYSIS_TEST_OBJECT',
  ANALYSISSUBJECTARRAY: 'ANALYSIS_SUBJECT_ARRAY',
  ANALYSISSTUDENTOBJECT: 'ANALYSIS_STUDENT_OBJECT',
};
